'use client';

import { PresaleContent } from '@/components/showtimes/presale-content';
import { Anchor } from '@/components/ui/anchor';
import { MoviePoster } from '@/types/movie-poster';
import { buildMovieUrlWithDate } from '@/utils/url-params';

type PreFirstShowtimeNoShowtimeContentComponentProps = {
  dataLinkCategory?: string;
  dataLinkName?: string;
  firstShowDate: Date;
  moviePoster: MoviePoster;
  preFirstShowtimeMessage: string;
};

export const PreFirstShowtimeNoShowtimeContentComponent = ({
  dataLinkCategory,
  dataLinkName,
  firstShowDate,
  moviePoster,
  preFirstShowtimeMessage,
}: PreFirstShowtimeNoShowtimeContentComponentProps): React.JSX.Element => {
  const dateLabel = firstShowDate.toLocaleDateString('en-US', { day: 'numeric', month: 'long' });
  const anchorHref = buildMovieUrlWithDate(moviePoster.movieUrl, firstShowDate);

  return (
    <PresaleContent analyticsLinkName={`Movie Details Dialog Pre First Showtime Link - ${moviePoster.movieTitle}`}
      contentClassName="flex flex-col gap-3 lg:flex-row lg:items-center md:justify-between"
      headingDataTest="pre-first-showtime-dialog-header"
      iconClassName="icon w-24 flex-none"
      linkDataTest="dialog-link-movie-details"
      messageDataTest="pre-first-showtime-dialog-message"
      presaleMessage={preFirstShowtimeMessage}
    >
      <Anchor data-test="link-pre-first-showtime-movie-details"
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        href={anchorHref}
      >
        View {dateLabel} Showtimes
      </Anchor>
    </PresaleContent>
  );
};
